var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProformaInvoicesIssued(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_1ee79185ada958f8b80878d64e07f38a35fd8629f46e39c3c2abba6ca6ae65fb",
    x1: 85.56,
    y1: 108.82,
    x2: 130.69,
    y2: 108.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M117.2 57.32s-1.51-8.75-8.76-8.75-9.18 8.75-9.18 8.75l18.8 14.26M100.12 71.58s1.52 8.75 8.76 8.75 9.18-8.75 9.18-8.75M108.66 41.11v7.46M108.66 80.33v7.46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M117.2 57.32s-1.51-8.75-8.76-8.75-9.18 8.75-9.18 8.75l18.8 14.26M100.12 71.58s1.52 8.75 8.76 8.75 9.18-8.75 9.18-8.75M108.66 41.11v7.46M108.66 80.33v7.46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_0_1ee79185ada958f8b80878d64e07f38a35fd8629f46e39c3c2abba6ca6ae65fb)",
    d: "M86.81 108.82h42.63M86.81 119.93h42.63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M68.2 45.72H50.5V29a8.86 8.86 0 0117.7 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M59.35 20.38h79.72a8.73 8.73 0 018.85 8.55V137H68.16V45.68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProformaInvoicesIssued);
export default __webpack_public_path__ + "static/media/proformaInvoicesIssued.501cc390075bcc5b27496dd5bf0a96f4.svg";
export { ForwardRef as ReactComponent };